export default [{
        value: '',
        label: '全部'
    }, {
        value: '1',
        label: '返佣'
    }, {
        value: '2',
        label: '分润'
    }, {
        value: '3',
        label: '提现'
    }, {
        value: '4',
        label: '调账'
    }, {
        value: '5',
        label: '实名认证'
    }, {
        value: '6',
        label: '短信'
    },{
        value: '7',
        label: '推广奖励'
    },
    {
        value: '8',
        label: '营销收益'
    }, {
        value: '9',
        label: '平台分红'
    }, {
        value: '10',
        label: '网申卡分润'
    },{
        value: '11',
        label: '提现分润'
    },{
        value: '12',
        label: '卡测评'
    },{
        value: '13',
        label: '冻结'
    },{
        value: '14',
        label: '解冻'
    },{
        value: '15',
        label: '扣款'
    },{
        value: '16',
        label: '拼刷奖励'
    },
];




// WEBPACK FOOTER //
// ./src/service/constant/TranTypes.js